import { ClientPortalCopyKey, clientPortalTraductor } from '../traductor/clientPortal';

type Copy = (
  key: ClientPortalCopyKey,
  vars?: Record<string, string | number>,
) => string;

const spanish: Copy = (key, vars) => clientPortalTraductor('es', key, vars);

/**
 * Vigencia del documento en la unidad que cierra exacta: años (múltiplo de
 * 365), si no meses (múltiplo de 30), si no días. Sin límite, cero o un valor
 * inválido no se muestran.
 */
export function formatRequirementMaxAge(
  days: number | null | undefined,
  t: Copy = spanish,
): string | null {
  if (days == null || !Number.isFinite(days) || days <= 0) return null;
  const n = Math.trunc(days);
  const exact = (count: number, one: ClientPortalCopyKey, many: ClientPortalCopyKey) =>
    count === 1 ? t(one) : t(many, { n: count });
  if (n % 365 === 0) return exact(n / 365, 'reqMaxAgeYearOne', 'reqMaxAgeYearMany');
  if (n % 30 === 0) return exact(n / 30, 'reqMaxAgeMonthOne', 'reqMaxAgeMonthMany');
  return exact(n, 'reqMaxAgeDayOne', 'reqMaxAgeDayMany');
}
